import { useNavigation } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LoadingScreen } from './components/loading-screen'
import { useRouteGuard } from './hooks/useRouteGuard'
import Page from './features/Page'
import { useLoadingStore } from './store/loadingStore'

const queryClient = new QueryClient()

function App() {
  useRouteGuard()

  const navigation = useNavigation()
  const isNavigating = Boolean(navigation.location)
  const { isLoading, message } = useLoadingStore()

  return (
    <QueryClientProvider client={queryClient}>
      <Page />
      {(isNavigating || isLoading) && <LoadingScreen message={message || 'Đang tải dữ liệu...'} />}
    </QueryClientProvider>
  )
}

export default App
